import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { UsersService } from '../../main-layout/users/users.service';

@Component({
  selector: 'app-exceldownload',
  templateUrl: './exceldownload.component.html',
  styleUrls: ['./exceldownload.component.css']
})
export class ExceldownloadComponent {

  dowload_api_url = '';
  filename = '';
  message = '';
  parentdata: any
  constructor(public config: DynamicDialogConfig, private utilityservice: Utilityservice,
    private spinner: NgxSpinnerService, private UsersService: UsersService,
    public ref: DynamicDialogRef) {
    this.parentdata = this.config.data;
    console.log(this.parentdata, "prentdata");

  }
  exceldatadownload() {
    this.spinner.show();
    this.utilityservice.downloadExcelData(this.parentdata.downloadapi, this.parentdata.method, this.parentdata.payload).subscribe({
      next: (response: Blob) => {
        const blob = new Blob([response],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.parentdata.excelname;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.spinner.hide();
        this.ref.close();
        Swal.fire('File downloaded successfully!', '', 'success');
      },
      error: error => {
        this.spinner.hide();
        Swal.fire(error.error.message, '', 'error');
      }
    });

  }
  closemodel() {
    this.ref.close()

  }

  syncData() {
     this.spinner.show();
    // need to call schedular
     const payload = { orgId: this.parentdata.orgId, userId: this.parentdata.userId };
    this.UsersService.syncData(payload).subscribe({
      next: (response: any) => {                 
         Swal.fire("User's mapped data is synced successfully!", "Now you can download the user's productwise data mapping report.", "success").then(() => {
          });
          this.spinner.hide();
      },
      error: (error) => {
        Swal.fire({
          title: "Error duiring sync",
          text: error.error.message || "An unexpected error occurred.",
          icon: "error",
        });
        this.spinner.hide();
      },
    }); 
  }

   

}
